var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-input',{staticStyle:{"width":"260px","margin-bottom":"10px"},attrs:{"placeholder":"Tìm kiếm..."},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}}),_c('a-table',{attrs:{"rowKey":"id","size":"small","bordered":"","columns":_vm.columns,"data-source":_vm.lstShow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }